// extracted by mini-css-extract-plugin
export default {"inner_page_padding":"PageLayout_inner_page_padding__WJr2c"};